export const useSSROrigin = () => {
  const getOrigin = () => {
    if (import.meta.server) {
      const { public: env } = useRuntimeConfig()
      const { req } = useRequestEvent()!
      // console.log('headers', req.headers)
      const proto = req.headers['x-forwarded-proto'] || 'https'
      const host = req.headers['x-forwarded-host'] || req.headers.host || `${env.config.toPath_url}`
      return `//${host}`
    }
    return window.location.origin
  }

  return useState('origin', getOrigin)
}
